import React, { Component } from 'react';
import '../../Style/login.css';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AVAGrid extends Component {
  constructor() {
    super();
    this.state = {
     
    };

   
  }

  
  onClickSubMenuItem = (e)=>{
    this.props.updateActiveSubMenu(e);
    this.props.updateActiveData({item:this.props.activeMenu,subitem:e});
  }



  render() {
    var blocks = this.props.menuList.filter(item=>item.ITEM === this.props.activeMenu).map((item,i)=>{
      return( 
      <div key={i} className="navigation-block" onClick={this.onClickSubMenuItem.bind(this,item.SUBITEM)}>
        <div className="block-icon"><FontAwesomeIcon icon="table" /></div>
        <div className="block-title">{item.SUBITEM}</div>
      </div>
    );
    });
    return (
      <div className="Grid-container">
        {blocks}
      </div>
      
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    activeURI : state.appReducer.activeURI,
    activeMenu: state.appReducer.activeMenu,
    menuList: state.apiReducer.menuList,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveMenu: (uri) => dispatch(repositoryActions.updateActiveMenu(uri)),
    updateActiveSubMenu:(uri) => dispatch(repositoryActions.updateActiveSubMenu(uri)),
    updateActiveData:(uri) => dispatch(repositoryActions.updateActiveData(uri)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(AVAGrid);
